// export const BaseUrl = "http://apa.quixdev.de:8000"
export const BaseUrl = ''

// console.log(window.location.hostname);
// "http://apa.quixdev.de:8000"
// "https://apa.sifa.hamburg"
// ""